// frontend/src/utils/mockUser.ts
import type { AccountInfo } from '@azure/msal-browser';
import type { UserProfile } from '../types';

/**
 * Centralna definicja "atrapy" (mocka) użytkownika na potrzeby środowiska deweloperskiego.
 * Ten obiekt jest używany zarówno na frontendzie (useAuth), jak i do komunikacji z backendem (apiClient).
 */
export const MOCK_USER: AccountInfo = {
    name: 'Lokalny Użytkownik Testowy',
    username: 'test@local.dev',
    homeAccountId: 'mock-home-account-id',
    environment: 'mock-env',
    tenantId: 'mock-tenant-id',
    localAccountId: 'mock-local-account-id',
    idTokenClaims: {
        preferred_username: 'test@local.dev',
        oid: 'test-user-id',
        name: 'Lokalny Użytkownik Testowy',
    }
};

// 2. Default mock profile for local DEV (Free by default — use DemoAccessSwitcher or Stripe for Pro UI).
export const DEFAULT_USER_PROFILE: UserProfile = {
    id: 'test-user-id',
    email: 'test@local.dev',
    name: 'Lokalny Użytkownik Testowy',
    plan: 'Free',
    subscriptionStatus: 'NONE',
};

export const getMockProfileFromStorage = (): UserProfile => {
    const stored = localStorage.getItem('mock_user_db');
    if (stored) {
        return JSON.parse(stored);
    }
    // Jeśli nie ma w bazie, zapisz domyślny i zwróć
    localStorage.setItem('mock_user_db', JSON.stringify(DEFAULT_USER_PROFILE));
    return DEFAULT_USER_PROFILE;
};

export const updateMockProfileInStorage = (updates: Partial<UserProfile>): UserProfile => {
    const current = getMockProfileFromStorage();
    const updated = { ...current, ...updates };
    localStorage.setItem('mock_user_db', JSON.stringify(updated));
    return updated;
};